import React from "react";

import "./ProductFeatureCard.scss";

interface CardProps {
  imgSrc: string;
  imgAlt: string;
  title: string;
  description: string;
}

const ProductFeatureCard = ({ imgSrc, imgAlt, title, description }: CardProps) => {
  return (
    <div className="product-feature-card">
      <div className="card-image-box">
        <img src={imgSrc} alt={imgAlt} />
      </div>

      <h3 className="card-title">{title}</h3>
      <p className="p0 card-description">{description}</p>
    </div>
  );
};

export default ProductFeatureCard;
